<template>
  <div>
    <el-tabs :tab-position="tabPosition" v-model="activeName" style="height: 100%; padding-top: 15px;">
      <el-tab-pane
        v-for="(cell) in listCell"
        :key="cell.id"
        :label="cell.name"
        :name="cell.id"
      >
        <div class="cell_height">
          <div class="cell_name">{{cell.name}}</div>
          <el-button type="text" class="cell_chg_cel cell_chg" @click="chg_cell">修改</el-button>/
          <el-button type="text" class="cell_chg_cel cell_del" @click="del_cell">删除</el-button>
        </div>
        <div>
          <el-table
            :data="listCell_one"
            border>
            <el-table-column prop="type" label="类型"></el-table-column>
            <el-table-column prop="product" label="农产品"></el-table-column>
            <el-table-column prop="length" label="长度"></el-table-column>
            <el-table-column prop="width" label="宽度"></el-table-column>
            <el-table-column prop="longitude" label="经度"></el-table-column>
            <el-table-column prop="latitude" label="纬度"></el-table-column>
          </el-table>
        </div>
        <div class="margin_top_table">
          <div class="cell_height cell_name">传感器</div>
          <el-table
            :data="listSensor"
            border>
            <el-table-column prop="num" label="序号"></el-table-column>
            <el-table-column prop="name" label="传感器名称"></el-table-column>
            <el-table-column prop="addr" label="地址标识"></el-table-column>
            <el-table-column prop="product" label="产品名称"></el-table-column>
            <el-table-column fixed="right" label="操作">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="chg_sensor(scope.row)">编辑</el-button>
                <el-button type="text" size="small" class="sensor_del cell_chg_cel cell_del" @click="del_sensor(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="margin_top_table">
          <div class="cell_height cell_name">设备</div>
          <el-table
            :data="listEquip"
            border>
            <el-table-column prop="num" label="序号"></el-table-column>
            <el-table-column prop="defname" label="设备名称"></el-table-column>
            <el-table-column prop="type" label="设备类型"></el-table-column>
            <el-table-column prop="addr" label="地址标识"></el-table-column>
            <el-table-column prop="road" label="第几路继电器"></el-table-column>
            <el-table-column fixed="right" label="操作">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="chg_equip(scope.row)">编辑</el-button>
                <el-button type="text" size="small" class="sensor_del cell_chg_cel cell_del" @click="del_equip(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :visible.sync="display_cell" :before-close="handleClose">
      <div>
        <div class="addSensor_form">
          <el-form ref="form" :model="form" label-width="120px" class="demo-ruleForm">
            <el-form-item label="*生产单元名称">
              <el-input v-model="form.cell_name" placeholder="自定义"></el-input>
            </el-form-item>
            <el-form-item label="*生产单元类型">
              <el-select v-model="form.cell_type" placeholder="请选择生产单元类型" >
                <div v-for="(cellType,index) in listCellType" :key="index">
                  <el-option :label="cellType.desc" :value="cellType.celltype"></el-option>
                </div>
              </el-select>
            </el-form-item>
            <el-form-item label="*农产品">
              <el-select v-model="form.cell_prod" placeholder="请选择生产单元类型下的农产品" @click="getCellProd()">
                <div  v-for="(cellProd,index) in listCellProd" :key="index">
                  <el-option :label="cellProd" :value="cellProd"></el-option>
                </div>
              </el-select>
            </el-form-item>
            <el-form-item label="*生产单元长度">
              <el-input v-model="form.cell_length" placeholder="单位(米)"></el-input>
            </el-form-item>
            <el-form-item label="*生产单元宽度">
              <el-input v-model="form.cell_width"  placeholder="单位(米)"></el-input>
            </el-form-item>
            <el-form-item label="*生产单元经度">
              <el-input v-model="form.cell_longitude" placeholder="可通过百度地图查看"></el-input>
            </el-form-item>
            <el-form-item label="*生产单元纬度">
              <el-input v-model="form.cell_latitude" placeholder="可通过百度地图查看"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="display_cell = false">取 消</el-button>
        <el-button type="primary" @click="pre_cell">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="display_sensor" :before-close="handleClose">
      <div>
        <div class="addSensor_form">
          <el-form ref="form" :model="form" label-width="120px" class="demo-ruleForm">
            <el-form-item label="*选择生产单元">
              <el-select v-model="form.cell_id" >
                <div v-for="cell in listCell" :key="cell.id">
                  <el-option :label="cell.name" :value="cell.id"></el-option>
                </div>
              </el-select>
            </el-form-item>
            <el-form-item label="*传感器名称">
              <el-input v-model="form.sensor_name" placeholder="自定义"></el-input>
            </el-form-item>
            <el-form-item label="*传感器地址标识">
              <el-input v-model="form.sensor_addr" placeholder="范围：1-255"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="display_sensor = false">取 消</el-button>
        <el-button type="primary" @click="pre_sensor">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="display_equip" :before-close="handleClose">
      <div>
        <div class="addSensor_form">
          <el-form ref="form" :model="form" label-width="105px" class="demo-ruleForm">
            <el-form-item label="*选择生产单元">
              <el-select v-model="form.pond_id" placeholder="请选择生产单元" >
                <div v-for="pond in listCell" :key="pond.id">
                  <el-option :label="pond.name" :value="pond.id"></el-option>
                </div>
              </el-select>
            </el-form-item>
            <el-form-item label="*设备名称">
              <el-input v-model="form.equip_name" placeholder="自定义"></el-input>
            </el-form-item>
            <el-form-item label="*终端id">
              <el-select v-model="form.equip_term_id" placeholder="请选择终端" >
                <div v-for="(term,index) in listTerm" :key="index">
                  <el-option :label="term.name" :value="term.id"></el-option>
                </div>
              </el-select>
            </el-form-item>
            <el-form-item label="*485地址">
              <el-input v-model="form.equip_addr" placeholder="范围：1-255"></el-input>
            </el-form-item>
            <el-form-item label="*第几路继电器">
              <el-input v-model="form.equip_road"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="display_equip = false">取 消</el-button>
        <el-button type="primary" @click="pre_equip">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      tabPosition: 'right',
      display_cell: false,
      display_sensor: false,
      display_equip: false,
      activeName: '',
      listCell: {},
      listTerm: {},
      listCell_one: [],
      listSensor: [],
      listEquip: [],
      token: window.sessionStorage.getItem('token'),
      username: window.sessionStorage.getItem('username'),
      form: {
        cell_name: '', // 生产单元参数
        cell_length: '',
        cell_width: '',
        cell_type: '',
        cell_longitude: '',
        cell_latitude: '',
        cell_prod: '',
        cell_id: '', // 传感器参数
        sensor_name: '',
        sensor_addr: '',
        pond_id: '', // 设备参数
        equip_name: '',
        equip_term_id: '',
        equip_addr: '',
        equip_road: ''
      },
      listCellType: {},
      listCellProd: {},
      sensorId: '',
      equip_id: '',
      user_id: ''
    }
  },
  methods: {
    // 获取 用户的所有生产单元
    getUserCells () {
      this.axios.get(this.$store.state.ip + 'celldef/listUserCells',
        {
          params: {'username': this.username},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.listCell = res.data.data.list
        // console.log(res.data.data.list)
        for (let i = 0; i < this.listCell.length; i++) {
          this.listCell[i].id = this.listCell[i].id.toString()
          if (this.listCell[i].product == null) {
            this.listCell[i].product = 'null'
          }
        }
        this.activeName = this.listCell[0].id
      }).catch(err => {
        console.log(err)
      })
    },
    // 获取 用户的所有终端
    getUserTerm () {
      this.axios.get(this.$store.state.ip + 'termdef/listTermsByUsr',
        {
          params: {'user_name': this.username},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.listTerm = res.data.data.list
      }).catch(err => {
        console.log(err)
      })
    },
    // 获取 生产单元下的传感器
    getUsersSensors () {
      this.axios.get(this.$store.state.ip + 'sensordef/cellSensors',
        {
          params: {'cell_id': this.activeName},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.listSensor = res.data.data
        for (let i = 0; i < this.listSensor.length; i++) {
          this.listSensor[i].num = i + 1
          if (!(/^[a-z]+$/.test(this.listSensor[i].name[0]) || /^[A-Z]+$/.test(this.listSensor[i].name))) {
            this.listSensor[i].name = this.listSensor[i].name.split(/[a-z]/, 1).toString()
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 获取 生产单元下的设备
    getUserEquips () {
      this.axios.get(this.$store.state.ip + 'equipdef/listEquips',
        {
          params: {'cell_id': this.activeName},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.listEquip = res.data.data
        for (let i = 0; i < this.listEquip.length; i++) {
          this.listEquip[i].num = i + 1
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 初始化 生产单元form
    chg_cell () {
      this.display_cell = true
      this.getCellTypes()
      for (let i = 0; i < this.listCell.length; i++) {
        if (this.listCell[i].id === this.activeName) {
          this.form.cell_name = this.listCell[i].name
          this.form.cell_length = this.listCell[i].length
          this.form.cell_width = this.listCell[i].width
          this.form.cell_type = this.listCell[i].type
          this.form.cell_longitude = this.listCell[i].longitude
          this.form.cell_latitude = this.listCell[i].latitude
          this.form.cell_prod = this.listCell[i].product
          break
        }
      }
    },
    // 初始化 传感器form
    chg_sensor (row) {
      this.display_sensor = true
      this.sensorId = row.id
      this.form.sensor_name = row.name
      this.form.sensor_addr = row.addr
      this.form.cell_id = this.activeName
    },
    // 初始化 设备form
    chg_equip (row) {
      this.display_equip = true
      this.getUserTerm()
      this.equip_id = row.id
      this.form.pond_id = this.activeName
      this.form.equip_name = row.defname
      this.form.equip_addr = row.addr
      this.form.equip_road = row.road
      this.form.equip_term_id = row.termid
    },
    // 更新 生产单元
    pre_cell () {
      this.display_cell = false
      let formdata = new FormData()
      formdata.append('id', this.activeName)
      formdata.append('length', this.form.cell_length)
      formdata.append('width', this.form.cell_width)
      formdata.append('longitude', this.form.cell_longitude)
      formdata.append('latitude', this.form.cell_latitude)
      formdata.append('cell_type', this.form.cell_type)
      formdata.append('agri_prod', this.form.cell_prod)
      formdata.append('cell_name', this.form.cell_name)
      formdata.append('user_name', this.username)
      this.axios.post(this.$store.state.ip + 'celldef/updateCell', formdata,
        {
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.$message.success('修改成功')
        this.getUserCells()
        this.listCell_one[0].length = this.form.cell_length
        this.listCell_one[0].width = this.form.cell_width
        this.listCell_one[0].longitude = this.form.cell_longitude
        this.listCell_one[0].latitude = this.form.cell_latitude
        this.listCell_one[0].cell_type = this.form.cell_type
        this.listCell_one[0].agri_prod = this.form.cell_prod
        this.listCell_one[0].cell_name = this.form.cell_name
      }).catch(err => {
        console.log(err)
        this.$message.success('修改失败')
      })
    },
    // 更新 传感器
    pre_sensor () {
      this.display_sensor = false
      let formdata = new FormData()
      formdata.append('id', this.sensorId)
      formdata.append('cell_id', this.form.cell_id)
      formdata.append('addr', this.form.sensor_addr)
      formdata.append('sensor_name', this.form.sensor_name)
      formdata.append('user_name', this.username)
      this.axios.post(this.$store.state.ip + 'sensordef/updateSensor', formdata, {headers: {'Authorization': 'Bearer ' + this.token}}).then(res => {
        this.$message.success('修改成功')
        this.getUsersSensors()
      }).catch(err => {
        console.log(err)
        this.$message.success('修改失败')
      })
    },
    // 更新 设备
    pre_equip () {
      this.display_equip = false
      let formdata = new FormData()
      formdata.append('id', this.equip_id)
      formdata.append('cell_id', this.form.pond_id)
      formdata.append('equip_name', this.form.equip_name)
      formdata.append('term_id', this.form.equip_term_id)
      formdata.append('addr', this.form.equip_addr)
      formdata.append('road', this.form.equip_road)
      this.axios.post(this.$store.state.ip + 'equipdef/updateEquip', formdata, {headers: {'Authorization': 'Bearer ' + this.token}}).then(res => {
        this.$message.success('修改成功')
        this.getUserEquips()
      }).catch(err => {
        console.log(err)
        this.$message.success('修改失败')
      })
    },
    // 查询 农产品
    getCellProd () {
      this.axios.get(this.$store.state.ip + 'celldef/listAgriProducts',
        {
          params: {'celltype': this.form.cell_type},
          headers: {'Authorization': 'Bearer ' + window.sessionStorage.getItem('token')}
        }).then(res => {
        this.listCellProd = res.data.data
        // console.log(res.data.data)
      }).catch(err => {
        console.log(err)
      })
    },
    // 查询 生产单元类型
    getCellTypes () {
      this.axios.get(this.$store.state.ip + 'celldef/listCellTypes',
        {
          headers: {'Authorization': 'Bearer ' + window.sessionStorage.getItem('token')}
        }).then(res => {
        this.listCellType = res.data.data
        // console.log(res.data.data)
      })
    },
    // 删除 生产单元
    del_cell () {
      this.$confirm('此操作将永久删除该生产单元, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.axios.delete(this.$store.state.ip + 'celldef/delCell',
          {
            params: {'id': this.activeName},
            headers: {'Authorization': 'Bearer ' + this.token}
          }).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.getUserCells()
        }).catch(err => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info'
        })
      })
    },
    // 删除 传感器
    del_sensor (row) {
      this.$confirm('此操作将永久删除该传感器, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.axios.delete(this.$store.state.ip + 'sensordef/deleteSensor',
          {
            params: {'sid': row.id},
            headers: {'Authorization': 'Bearer ' + this.token}
          }).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.getUsersSensors()
        }).catch(err => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info'
        })
      })
    },
    // 删除 设备
    del_equip (row) {
      this.$confirm('此操作将永久删除该设备, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.axios.delete(this.$store.state.ip + 'equipdef/delEquip',
          {
            params: {'id': row.id},
            headers: {'Authorization': 'Bearer ' + this.token}
          }).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.getUserEquips()
        }).catch(err => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info'
        })
      })
    },
    // 弹窗
    handleClose (done) {
      this.$confirm('确定关闭吗').then(() => {
        // function(done)，done 用于关闭 Dialog
        done()
      }).catch(() => {
      })
    }
  },
  created () {
    this.getUserCells()
  },
  watch: {
    'form.cell_type': function () {
      this.getCellProd()
    },
    'activeName': function () {
      this.listCell_one = []
      for (let i = 0; i < this.listCell.length; i++) {
        if (this.listCell[i].id === this.activeName) {
          this.listCell_one.push(this.listCell[i])
          break
        }
      }
      this.getUsersSensors()
      this.getUserEquips()
    }
  }
}
</script>

<style scoped>
.cell_height {
  text-align: left;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.cell_name {
  color: #333;
  font-size: 18px;
  font-weight: bold;
}
.cell_chg_cel {
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
}
.cell_chg {
  color: #409EFF;
  margin-left: 10px;
  margin-right: 5px;
}
.cell_del{
  color: #F56C6C;
  margin-left: 5px;
}
.sensor_del {
  font-weight: normal;
}
.addSensor_form {
  width: 400px;
  margin-left: 20px;
  margin-top: 30px;
}
.el-input, .el-select {
  margin-left: 10px;
  width: 300px;
}
.margin_top_table {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/control/cell.vue